import * as React from "react"

export type OrganizationProps = {
  color?: string
  fill?: string
}

export const Enterprise = (props: OrganizationProps) => {
  const { color = "currentColor", fill } = props

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 3.91667C2.75 3.27233 3.27233 2.75 3.91667 2.75H7.41667C8.061 2.75 8.58333 3.27233 8.58333 3.91667V12.6667H2.75V3.91667ZM4.5 4.5H6.83333V6.83333H4.5V4.5ZM6.83333 8.58333H4.5V10.9167H6.83333V8.58333Z"
        fill={color}
      />
      <path
        d="M8.5835 6.25H12.0835C12.7278 6.25 13.2502 6.77233 13.2502 7.41667V12.6667H8.5835V10.9167H11.5002V9.75H8.5835V9.16667H11.5002V8H8.5835V6.25Z"
        fill={color}
      />
    </svg>
  )
}
